"use client";
import React from "react";
import Layout from "./Layout";
import ShopRowCard from "components/home/Card/ShopRowCard";
import Pagination from "components/common/Pagination";
import { get } from "utils/lodash";
import { useT } from "providers/I18nProvider";
import { categoryNameKeyByCode } from "utils/constant";

const chipCls = (on: boolean) =>
  `whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-semibold border transition-colors ${
    on
      ? "bg-primary text-white border-primary"
      : "bg-white text-black01 border-[#d8f3f2] hover:border-primary/60"
  }`;

/**
 * "Địa điểm khác": card ngang 3 cột + chip filter danh mục + phân trang.
 */
const ShopSection: React.FC<{
  pagination: any;
  title: string;
  description: string;
  categories?: any[];
  category?: string;
  onChangeCategory?: (id: string) => void;
}> = ({
  pagination,
  title,
  description,
  categories = [],
  category = "",
  onChangeCategory,
}) => {
  const t = useT();
  const items: any[] = pagination?.items || [];
  return (
    <Layout
      iconName="location"
      title={title}
      description={description}
      className="bg-[#fafafa]"
    >
      {categories.length > 0 && (
        <div className="flex gap-2 overflow-x-auto snap-x snap-mandatory scroll-px-4 md:snap-none [&>*]:snap-start scrollbar-hide px-4 md:px-6 pb-4">
          <button
            type="button"
            className={chipCls(!category)}
            onClick={() => onChangeCategory?.("")}
          >
            {t("home.allCategories")}
          </button>
          {categories.map((cat: any) => {
            // CMS chỉ có tên tiếng Việt → map theo code sang key i18n
            const nameKey = categoryNameKeyByCode(get(cat, "code"));
            return (
              <button
                key={get(cat, "id")}
                type="button"
                className={chipCls(category === get(cat, "id"))}
                onClick={() => onChangeCategory?.(get(cat, "id"))}
              >
                {nameKey ? t(nameKey) : get(cat, "name")}
              </button>
            );
          })}
        </div>
      )}
      <div
        className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-3 px-4 md:px-6 transition-opacity ${
          pagination?.isLoading ? "opacity-60" : ""
        }`}
      >
        {items.map((item: any) => (
          <ShopRowCard key={get(item, "id")} shop={item} />
        ))}
      </div>
      <div className="flex justify-center mt-5">
        <Pagination pagination={pagination} />
      </div>
    </Layout>
  );
};

export default ShopSection;
